import { setCookie } from "nookies";
import * as authConstants from "../constants";
import { getDecodedIdToken, getStoredIdToken, isAppReviewer } from "./web";

export const login = async (email, password, resetStore) => {
  return Promise.resolve(window.cypressBridge.login());
};

export const signupAndLogin = login;

export const saveAuthToken = () => {
  const idToken = new URLSearchParams(document.location.search).get("id_token");
  setCookie({}, authConstants.idToken, idToken, { path: "/" });
  return Promise.resolve(true);
};

export { getDecodedIdToken, getStoredIdToken, isAppReviewer };
